import { render } from "./OrdersList.vue?vue&type=template&id=1ff8509c&scoped=true&ts=true"
import script from "./OrdersList.vue?vue&type=script&lang=ts"
export * from "./OrdersList.vue?vue&type=script&lang=ts"

import "./OrdersList.vue?vue&type=style&index=0&id=1ff8509c&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff8509c"]])

export default __exports__